import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators, compose} from 'redux';
import * as applicationActions from '../../actions/applicationActionCreators';
import {withRouter} from 'react-router-dom';
import Layout from '../../layout/Layout';

import {useUnmount} from 'react-use';

import SeoTags from '../../routes/SeoTags';


const StaticPage = (props) => {
  const
    [currentPath, setCurrentPath] = useState(null),
    page = props.applicationState.static_page,
    slug = props.match.path?.replaceAll('/', ''),
    {is_mobile, current_city} = props.applicationState;

  useEffect(() => {
    if (slug === currentPath) {
      return;
    }

    setCurrentPath(slug);
    props.applicationActions.fetchStaticPage(slug);
  }, [slug, props.applicationActions.fetchStaticPage]);

  useUnmount(() => {
    props.applicationActions.resetStaticPage();
  });

  return (
    <Layout
      className='static-page'
      breadcrumbs={[
        {label: page?.title}
      ]}
    >
      {
        page ?
          <SeoTags
            seo_context={{
              title: page?.title,
              description: page?.title,
              keywords: page?.title,
            }}
          />
          : null
      }

      <div className='container'>
        {
          page ? <div className='html-content' dangerouslySetInnerHTML={{__html: page.body}} /> : null
        }
      </div>
    </Layout>
  );
}

const mapDispatchToProps = (dispatch) => {
    return {
      applicationActions: bindActionCreators(applicationActions, dispatch)
    };
  },

  mapStateToProps = ({applicationState}) => {
    return {
      applicationState
    };
  },

  withConnect = connect(
    mapStateToProps,
    mapDispatchToProps
  );

export default withRouter(compose(withConnect)(StaticPage));
